module.exports = __webpack_public_path__ + "img/now_gg.6c4a6b2.jpg";